import { api } from "@/lib/api";
import { baseClips } from "@/lib/syncEdit";

// Beat map of the project audio (source time) + current edit, shared by preview and on-device export.
let state = null; // { env, hop, beats, clips }

export async function loadBeatMap(projectId) {
  try {
    const bm = await api.projectBeats(projectId);
    state = { ...(state || {}), env: bm.env || [], hop: bm.hop || 0.01, beats: bm.beats || [] };
  } catch { /* beat sync falls back to word timing */ }
}
export const setBeatClips = (mediaTracks) => { if (state) state.clips = baseClips(mediaTracks); else state = { clips: baseClips(mediaTracks) }; };
export const clearBeatMap = () => { state = null; };

function toSource(t) {
  const clips = state?.clips;
  if (!clips || !clips.length) return t;
  for (const c of clips) {
    if (t >= (c.start || 0) && t <= (c.end || 0)) {
      const k = (c.source_end - (c.source_start || 0)) / Math.max(1e-3, (c.end || 0) - (c.start || 0));
      return (c.source_start || 0) + (t - (c.start || 0)) * k;
    }
  }
  return null;
}

// { level: loudness 0..1, pulse: 1 on a beat decaying to 0, phase: seconds since last beat } or null.
export function beatAt(t) {
  if (!state || !state.env || !state.env.length) return null;
  const s = toSource(t);
  if (s == null) return { level: 0, pulse: 0, phase: 1 };
  const i = Math.max(0, Math.min(state.env.length - 1, Math.round(s / state.hop)));
  const b = state.beats;
  let lo = 0, hi = b.length - 1, last = -1;
  while (lo <= hi) { const m = (lo + hi) >> 1; if (b[m] <= s) { last = b[m]; lo = m + 1; } else hi = m - 1; }
  const phase = last < 0 ? 9 : s - last;
  return { level: state.env[i], pulse: Math.exp(-phase * 7), phase };
}
